export default "https://www.courierhelper.app";
// export default "http://localhost:5000";

// httpss://www.youtube.com/watch?v=oBWBDaqNuws&ab_channel=notJust%E2%80%A4dev
